import { ROUTES_CONST } from "./constants";


export function convert_routes(arr) {
  let mainArr = [];

  function Recur(arr) {
    arr.forEach((item) => {
      if (item.children.length > 0) {
        mainArr.push({
          path: item.path,
          breadcrumb: item.name,
          metaTitle: item.metaTitle,
        })
        Recur(item.children);
      } else {
        return mainArr.push({
          path: item.path,
          breadcrumb: item.name,
          metaTitle: item.metaTitle,
        })
      }
    }
    )
  }

  Recur(arr);
  return mainArr;
}

export function convert_routes_startsWith_products(arr) {
  let mainArr = [];

  function Recur(arr) {
    arr.forEach((item) => {
      if (item.children.length > 0) {
        mainArr.push({
          path: item.path.replace('/catalog', '/products'),
          breadcrumb: item.name,
          metatitle: item.metaTitle
        });
        Recur(item.children);
      } else {
        return mainArr.push({
          path: item.path.replace('/catalog', '/products'),
          breadcrumb: item.name,
          metatitle: item.metaTitle
        });
      }
    }
    );
  }

  Recur(arr);
  return mainArr;
}


export function getDataFromRoutes(location, routes, uid = null, token = null) {
  let data = {
    title: 'Неизвестная страница',
    metaTitle: 'Неизвестная страница'
  }
  let index = -1;
  if (uid && token) {
    index = routes.findIndex(route => {
      if (route.path.includes(':uid') && route.path.includes(':token')) {
        let formatRoute = route.path.replace(':uid', uid).replace(':token', token);
        return (formatRoute === location);
      }
      return false;
    });
  } else if (token) {
    index = routes.findIndex(route => {
      if (route.path.includes(':token')) {
        let formatRoute = route.path.replace(':token', token);
        return (formatRoute === location);
      }
      return false;
    });
  } else {
    index = routes.findIndex(route => route.path === location);
  }
  if (index > -1) {
    data.title = routes[index].breadcrumb;
    data.metaTitle = routes[index].metaTitle;
  } else {
    data.title = routes[0].breadcrumb;
    data.metaTitle = routes[0].metaTitle;
  }
  return data;
}

export function getDataFromArrayWithSlug(slug, array) {
  let data = {
    title: 'Неизвестная страница',
    metaTitle: 'Неизвестная страница',
  }
  let index = array.findIndex(item => item.slug === slug);

  if (index > -1) {
    data.title = array[index].name;
    data.metaTitle = array[index].metaTitle;
  }
  return data;
}

export function getArrayForRoutes(source) {
  let resultList = [];
  source.forEach(item => {
    resultList.push({
      path: item.path,
      breadcrumb: item.name,
      metaTitle: item.metaTitle
    })
  });
  return resultList;
}

export function getDataFromCatalogRoutes(location, navigate, routes, slug1 = null) {
  let index = -1;
  if (location === '/catalog') {
    return ROUTES_CONST.find(route => route.path === '/catalog');
  }
  if (location.startsWith('/catalog') && slug1) {
    index = routes.findIndex(route => route.path === location);
    if (index > -1) {
      return routes[index];
    }
  }

  return ROUTES_CONST[0];
}

export function getDataFromProductRoutes(location, navigate, routes, slug1 = null) {
  let index = -1;
  if (location === '/products') {
    return ROUTES_CONST.find(route => route.path === '/products');
  }
  if (location.startsWith('/products/') && slug1) {
    index = routes.findIndex(route => route.path === location);
    if (index > -1) {
      return routes[index];
    }
  }
  return ROUTES_CONST[0];
}


export function setMetaTags(
  metaTitle = '',
) {
  if (metaTitle) document.title = metaTitle;
}


export const setColorInterface = (colorsList) => {
  let root = document.getElementById('root');
  colorsList.forEach(color => {
    root.style.setProperty(`--${color.name}`, color.color);
  });
}

export const setSharpCorners = (sharp) => {
  const root = document.getElementById('root');
  const modal = document.getElementById('modal');
  const borderRadius = sharp ? '0px' : '4px';
  root.style.setProperty(`--corners`, borderRadius);
  modal.style.setProperty(`--corners`, borderRadius);
}

export const deepFindBySlug = (list, slug) => {
  for (const item of list) {
    if (item.slug === slug) {
      return item;
    }
    if (item.children.length) {
      const found = deepFindBySlug(item.children, slug);
      if (found) return found;
    }
  }
  return null;
};

export const deepFindByPath = (list, path) => {
  for (const item of list) {
    if (item.path === path) {
      return item;
    }
    if (item.children.length) {
      const found = deepFindByPath(item.children, path);
      if (found) return found;
    }
  }
  return null;
}

export const getArrayCategoriesWithProducts = (products, allCategories) => {

  let arr = [];

  if (!products.length) return arr;

  products.forEach(product => {
    const currCategory = deepFindBySlug(allCategories, product.category) ||
    {
      name: 'Товары без категорий',
      path: '/catalog',
      slug: 'catalog'
    };
    const indexCategoryInArray = arr.findIndex(item => item.categorySlug === currCategory.slug);
    if (indexCategoryInArray > -1) {
      arr[indexCategoryInArray].products.push(product);
    } else {
      arr.push({
        categoryName: currCategory.name,
        categoryPath: currCategory.path,
        categorySlug: currCategory.slug,
        products: [product]
      })
    }
  });

  return arr;
}

export function removeEmptyCategories(data) {
  const newData = [];
  for (const item of data) {
    if (item.total_active_products > 0) {
      const newItem = { ...item };
      if (item.children && item.children.length > 0) {
        newItem.children = removeEmptyCategories(item.children);
      }
      newData.push(newItem);
    }
  }
  return newData;
}

export const getQuantityCards = (
  currWidth, width1, width2, width3, width4,
  quantity1Start, quantity1Add, quantity2Start, quantity2Add,
  quantity3Start, quantity3Add, quantity4Start, quantity4Add
) => {

  const result = {
    quantityStart: quantity4Start,
    quantityAdd: quantity4Add
  }

  if (currWidth >= width4) {
    result.quantityStart = quantity4Start;
    result.quantityAdd = quantity4Add;
  } else if (currWidth >= width3) {
    result.quantityStart = quantity3Start;
    result.quantityAdd = quantity3Add;
  } else if (currWidth >= width2) {
    result.quantityStart = quantity2Start;
    result.quantityAdd = quantity2Add;
  } else {
    result.quantityStart = quantity1Start;
    result.quantityAdd = quantity1Add;
  }

  return result;
}
